import { render, staticRenderFns } from "./DefaultButton.vue?vue&type=template&id=3c3ce352"
import script from "./DefaultButton.vue?vue&type=script&lang=js"
export * from "./DefaultButton.vue?vue&type=script&lang=js"
import style0 from "./DefaultButton.vue?vue&type=style&index=0&id=3c3ce352&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports